import { DBTypes } from "@taabl/common-lib/constants/dbtypes";
import React from "react";
import { Col, Row } from "react-bootstrap";
import PageLoader from "../../components/PageLoader";
import useAuth from "../../contexts/useAuth";
import { Constants } from "../../libs/Constants";
import { get, getList } from "../../libs/dbFunctions";
import ProfitSummary from "../EmployeeDashboard/profitsummary";
import StockPriceGraph from "../EmployeeDashboard/stockpricegraph";
import AccountSummary from "./AccountSummary";
import useEmployeeContext from "./contexts/useEmployeeContext";
import "./EmployeeHome.scss";
import SetupComplete from "./SetupComplete";
import SignUpWithTaabl from "./SignUpWithTaabl";

const Dashboard = ({ empId }) => {
  const [loading, setLoading] = React.useState(true);
  const { activeCompany, user: loggedInUser } = useAuth();
  const [employeeTransactions, setEmployeeTransactions] = React.useState({
    results: [],
    balance: 0,
  });
  const [summary, setSummary] = React.useState(null);
  const { refreshEmployee, employee } = useEmployeeContext();
  React.useEffect(() => {
    if (!empId) {
      return;
    }
    if (loggedInUser && empId) {
      refreshEmployee(empId);
    }
  }, [empId, loggedInUser]);
  React.useEffect(() => {
    if (!employee || !activeCompany) {
      return;
    }
    loadData();
  }, [employee, activeCompany]);

  const loadData = async () => {
    setLoading(true);
    await loadUserData();
    setLoading(false);
  };

  const loadUserData = async () => {
    setLoading(true);
    await loadAccountSummary();
    await loadUserTransactions();
    setLoading(false);
  };

  const loadAccountSummary = async () => {
    let summaryResponse = await get(DBTypes.ACCOUNTSUMMARY, employee.id);
    if (summaryResponse) {
      setSummary(summaryResponse);
    }
  };

  const loadUserTransactions = async () => {
    //get the transactions for the user
    let userTransactions = await getList(
      Constants.dbTypes.TRANSACTION,
      activeCompany,
      {
        id: employee.id,
      }
    );
    if (userTransactions && userTransactions.results) {
      // sort the transactions based on created date
      userTransactions.results.sort((a, b) => b.created - a.created);
      setEmployeeTransactions(userTransactions);
    }
  };

  return (
    <PageLoader isActive={loading} individual={false}>
      <div className="container-fluid p-0">
        <SignUpWithTaabl user={employee} />
        <SetupComplete />
        <Row className="m-0">
          <Col sm={12} className="p-0">
            <ProfitSummary
              summary={summary}
              userObj={employee}
              transactions={employeeTransactions}
              refresh={() => {
                loadUserData();
              }}
            />
          </Col>
        </Row>
        {activeCompany && (
          <StockPriceGraph activeCompany={activeCompany} monthsToShow={23} />
        )}
        <AccountSummary
          summary={summary?.profitSummary || []}
          employee={employee}
        />
      </div>
    </PageLoader>
  );
};

export default Dashboard;
